import React from 'react';
import { ChartMenuItem } from '@/experiment-management-shared/components/Charts/Chart/types';
import { ListItem, SearchableList } from '@ds';
import styles from '@/experiment-management-shared/components/Charts/Chart/ChartHeaderMenu.module.scss';

const MAX_HEIGHT_LIST =
  typeof window !== 'undefined' ? window.innerHeight / 2 : 400;

export const ChartHeaderMenuItem: React.FC<{
  item: ChartMenuItem;
  selectedItemValue: string | null;
  onClick: (item: ChartMenuItem) => void;
}> = ({ item, onClick, selectedItemValue }) => (
  <ListItem
    onClick={() => onClick(item)}
    active={selectedItemValue === item.value && !item.subMenu}
    disabled={item.disabled}
  >
    <ListItem.Text primary={item.label} />
    {item.subMenu && (
      <ListItem.Submenu offset="0 4px 0 0">
        <div className={styles.menuContainer}>
          <SearchableList
            itemList={item.subMenu.items}
            searchField="label"
            hideSearch={!item.subMenu.withInput}
          >
            <SearchableList.Result
              maxHeight={MAX_HEIGHT_LIST}
              stickyHeadersEnabled
            >
              {(subItem: ChartMenuItem) => (
                <ListItem
                  key={subItem.value}
                  active={item.subMenu?.value === subItem.value}
                  onClick={() => item.subMenu?.onClick(subItem)}
                >
                  <ListItem.Text
                    primary={subItem.label}
                    secondary={subItem.secondary}
                  />
                </ListItem>
              )}
            </SearchableList.Result>
            <SearchableList.NotFound />
          </SearchableList>
        </div>
      </ListItem.Submenu>
    )}
  </ListItem>
);
